import { MessageSquare, Sparkles, Star } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const aiPhoneCallsForCustomerSurveysAr: TemplateAr = {
  name: 'مكالمات هاتفية بالذكاء الاصطناعي لاستطلاعات العملاء',
  description:
    'مكالمات آلية بالذكاء الاصطناعي لقياس رضا العملاء وجمع ملاحظاتهم ودرجات NPS.',
  category: 'المكالمات الهاتفية بالذكاء الاصطناعي',
  workflow: [
    { icon: MessageSquare, label: 'محفّز الاستطلاع' },
    { icon: Sparkles, label: 'الـ AI يتصل' },
    { icon: Star, label: 'الملاحظات مجموعة', final: true },
  ],
  detailDescription: {
    paragraph1:
      'اعرف وش يقول عميلك بمكالمة، مو باستطلاع ينتظر رد. الـ AI يتصل في التوقيت الأنسب، ويطرح أسئلة الاستطلاع بشكل طبيعي، ويستفسر أكثر عشان يوصل لملاحظات تفصيلية، ويسجّل الإجابات. ويعدّل أسئلته حسب رد العميل، ويصعّد الملاحظات السلبية فوراً.',
    paragraph2:
      'إجابات الاستطلاع توصل لمنصة التحليلات أو الـ CRM أو مستودع البيانات عندك. ودرجات NPS وتقييمات الرضا والملاحظات الحرفية تلقاها محفوظة للتحليل. والـ AI يكتشف المشكلات العاجلة، وينشئ تذاكر متابعة تلقائياً.',
  },
  benefits: [
    'معدلات الاستجابة للاستطلاع ترتفع',
    'ملاحظات أغنى من اللي يجيك بالإيميل',
    'الـ AI يرصد المنتقدين ويصعّدهم فوراً',
    'استطلاعات على نطاق واسع، بدون فريق يتصل',
    'الأسئلة تتغيّر حسب جواب العميل',
    'الـ AI يتتبّع اتجاهات NPS وCSAT تلقائياً',
  ],
};
